import React, { useEffect } from 'react';

import { ClearFiltersButton } from '../clear-filters-button/ClearFiltersButton';
import { HighlightsFilters } from '../highlights-filters/HighlightsFilters';
import { NewsList } from '../news-list/NewsList';
import { useNewsFilters } from '../side-accordion-filters/hooks/use-news-filters/useNewsFilters';
import { SideAccordionFilters } from '../side-accordion-filters/SideAccordionFilters';
import * as S from './NewsView.styles';

export const NewsView = () => {
  const {
    watchlistStates,
    marketsStates,
    sourcesStates,
    isFetchingMostRead,
    toggleResetChecked,
    toggleIsFetchingMostRead,
  } = useNewsFilters();

  const isShowResetButton =
    isFetchingMostRead ||
    !!watchlistStates.checkedCount ||
    !!marketsStates.checkedCount ||
    !!sourcesStates.checkedCount;
  const handleReset = () => {
    toggleIsFetchingMostRead(true);
    toggleResetChecked();
  };

  useEffect(() => {
    toggleResetChecked();
  }, []);

  return (
    <S.NewsViewRoot data-testid="news-lists-container">
      <S.LeftContent>
        <NewsList />
      </S.LeftContent>
      <S.RightContent>
        <HighlightsFilters
          isFetchMostRead={isFetchingMostRead}
          toggleIsFetchMostRead={toggleIsFetchingMostRead}
        />
        <SideAccordionFilters />
        {isShowResetButton && (
          <ClearFiltersButton
            data-testid="reset-all-filters"
            onClick={handleReset}
          />
        )}
      </S.RightContent>
    </S.NewsViewRoot>
  );
};
